const getters = {
  userInfo: state => state.user.userInfo,
}
export default getters